import { useState } from "react";
import { Link } from "react-router-dom";
import { useAccount } from "@/providers/AccountProvider";
import { useWhatsAppHealthQuery } from "@/hooks/useMetaData";
import { MetaHealthErrorList } from "@/components/connections/MetaHealthErrorList";

/** The notice bar across every page when Meta says this workspace's WhatsApp cannot send.
 *
 *  Only on `fail`: a warning belongs on the Connections card, and a bar that is always
 *  there stops being read. Shares the Connections card's query key, so both surfaces pay
 *  for one health read. Dismissing hides it until the next page load -- the account is
 *  still broken, and a permanent dismiss would let a ban go unnoticed. */
export function WhatsAppHealthNotice() {
  const { path, can } = useAccount();
  const health = useWhatsAppHealthQuery(true);
  const [dismissed, setDismissed] = useState(false);

  if (dismissed || health.data?.state !== "fail") return null;
  return (
    <div
      role="alert"
      className="flex items-start gap-3 border-b border-n-critical/35 bg-n-critical/10 px-4 py-2.5 text-[12.5px] text-n-critical"
    >
      <div className="min-w-0 flex-1">
        <p className="font-medium">WhatsApp can't send messages: {health.data.detail}</p>
        <MetaHealthErrorList errors={health.data.meta_errors} />
      </div>
      {can("connections.manage") ? (
        <Link to={path("/connections")} className="shrink-0 font-medium underline underline-offset-2">
          Open Accounts &amp; assets
        </Link>
      ) : null}
      <button
        type="button"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss notice"
        className="shrink-0 opacity-70 hover:opacity-100"
      >
        ✕
      </button>
    </div>
  );
}
